import { IconPin } from '@veneer/core';
import React from 'react';
import { useDependencyManagerContext } from 'src/contexts/dependencyManager';
import {
  HpAllInManageAddressHyperLinkClicked,
  InstantInkManageAddressHyperLinkClicked
} from 'src/utils/analytics';
import { URLS } from 'src/utils/urls';
import { SubscriptionsCardProps } from '../SubscriptionsCard/types';
import {
  CardContainer,
  Link,
  Gap8,
  History,
  EmptyContent
} from 'src/styles/styles';
import { getResourceId } from 'src/utils/utils';
import {
  Card,
  publishEvent,
  SubscriptionType
} from '@uma/react-commons/dist/index';
import ShipmentHistoryLink from './HistoryContent/Link';
import ShipmentHistoryContent from './HistoryContent';

export const Shipping = ({ subscription }: SubscriptionsCardProps) => {
  const { translate } = useDependencyManagerContext();
  const resourceId = getResourceId(subscription);

  const shipments = (
    <CardContainer>
      <Gap8>
        <div
          data-component="SubscriptionsShippingNameValue"
          className="caption"
        >
          {subscription?.shippingAddress?.firstName}{' '}
          {subscription?.shippingAddress?.lastName}
        </div>
        <div
          data-component="SubscriptionsShippingStreetValue"
          className="caption"
        >
          {subscription?.shippingAddress?.address}
        </div>
        <div
          data-component="SubscriptionsShippingCityStateCodeValue"
          className="caption"
        >
          {subscription?.shippingAddress?.city},{' '}
          {subscription?.shippingAddress?.state}{' '}
          {subscription?.shippingAddress?.postalCode}
        </div>
        <div
          data-component="SubscriptionsShippingPhoneValue"
          className="caption"
        >
          {subscription?.shippingAddress?.phoneNumber}
        </div>
        <div className="caption">
          <Link
            data-testid="ManageAddressLink"
            href={URLS.UnifiedShippingBillingURL}
            target="_blank"
            rel="noreferrer"
            onClick={() =>
              publishEvent(
                subscription?.type === SubscriptionType.INSTANT_INK
                  ? InstantInkManageAddressHyperLinkClicked(
                      resourceId,
                      subscription.startDate
                    )
                  : HpAllInManageAddressHyperLinkClicked(
                      resourceId,
                      subscription.startDate
                    )
              )
            }
          >
            {`${translate('subscriptions.manageAddress', 'Manage address')}`}
          </Link>
        </div>
      </Gap8>
      <History>
        <ShipmentHistoryContent subscription={subscription} />
        <ShipmentHistoryLink
          subscription={subscription}
          resourceId={resourceId}
        />
      </History>
    </CardContainer>
  );

  const noShipments = (
    <EmptyContent>
      <IconPin />
      <div className="caption">
        <a
          href={URLS.UnifiedShippingBillingURL}
          target="_blank"
          rel="noreferrer"
        >
          {`${translate(
            'subscriptions.addShippingAddress',
            'Add shipping address'
          )}`}
        </a>
      </div>
    </EmptyContent>
  );

  return (
    <Card
      title={{
        content: translate('subscriptions.shipping', 'Shipping') as string
      }}
      data-testid="payment-section"
    >
      {subscription?.shippingAddress ? shipments : noShipments}
    </Card>
  );
};
